/**
 * Nord Living wordmark. Rendered as a CSS mask over `bg-primary` so the logo
 * follows the theme (brand brown in light mode, warm tan in dark mode).
 */

import { cn } from '@/lib/utils';
import { BRAND } from '@/config/brand';

interface BrandLogoProps {
  className?: string;
  /** Hide from assistive tech when adjacent text already names the brand. */
  decorative?: boolean;
}

export function BrandLogo({ className, decorative = false }: BrandLogoProps) {
  const a11y = decorative
    ? { 'aria-hidden': true as const }
    : { role: 'img', 'aria-label': `${BRAND.name} — ${BRAND.descriptor}` };
  return (
    <span
      {...a11y}
      className={cn(
        'block aspect-[911/206] bg-primary',
        "[mask-image:url('/brand/nord-living-logo.png')] [mask-position:center] [mask-repeat:no-repeat] [mask-size:contain]",
        className,
      )}
    />
  );
}
